import {
    Dialog,
    DialogBody,
    DialogDisclosure,
    DialogDismiss,
    DialogProvider
} from '@/components/ui/dialog-atoms/DialogAtoms'
import {Text} from '@/components/ui/text/Text'
import {useTranslation} from '@/translations/i18n'
import {View} from '../types'
import {Button} from '@/components/ui/button/Button'
import {Spinner} from '@/components/ui/spinner/Spinner'
import {StyledFooter} from './delete-view-dialog/style'

export const SaveViewDialog = ({
    view,
    trigger,
    isPending,
    onConfirm
}: {
    view: View
    trigger: React.ReactElement
    isPending: boolean
    onConfirm: () => void
}) => {
    const {t} = useTranslation()
    return (
        <DialogProvider>
            <DialogDisclosure render={trigger} />
            <Dialog width="400px">
                <DialogBody gap={2}>
                    <Text render="h1" size="textXl" weight={'500'}>
                        {t('commons:view_save_for_all_confirm_title')}
                    </Text>
                    <Text size="textMd" palette="neutral" shade="600">
                        {t('commons:view_save_for_all_confirm', {name: view.name})}
                    </Text>
                </DialogBody>
                <StyledFooter>
                    <DialogDismiss render={<Button variant="secondary">{t('commons:cancel')}</Button>} />
                    <Button variant="primaryNeutral" onClick={onConfirm} disabled={isPending}>
                        {t('commons:save_for_all')}
                        {isPending && <Spinner />}
                    </Button>
                </StyledFooter>
            </Dialog>
        </DialogProvider>
    )
}
